import { Component } from '@lessonup/teaching-core';
import React from 'react';
import FakeSpinnerSvg from '../../svgIcons/FakeSpinnerSvg';
import ComponentContainer from '../componentContainer/ComponentContainer';

interface Props {
  component: Component.Spinner;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- auto-generated TECH-258
  onClickHandler?: Function;
  isThumb?: boolean;
}

export default class SpinnerComponentView extends React.PureComponent<Props> {
  render() {
    return (
      <ComponentContainer component={this.props.component}>
        <FakeSpinnerSvg />
      </ComponentContainer>
    );
  }
}
